module.exports = __webpack_public_path__ + "static/media/1_001.9632029b.jpeg";